import React from 'react';

const SupportTeams = () => {
    const teams = [
        {
            name: "Support Technique",
            description: "Problèmes d'intégration et questions techniques",
            email: "tech@netikash.com",
            responseTime: "2 heures",
            availability: "24h/24",
            color: "from-blue-500 to-cyan-500"
        },
        {
            name: "Support Commercial",
            description: "Questions tarifaires et partenariats",
            email: "sales@netikash.com",
            responseTime: "4 heures",
            availability: "8h-18h",
            color: "from-amber-500 to-yellow-500"
        },
        {
            name: "Support Entreprise",
            description: "Clients enterprise avec support dédié",
            email: "enterprise@netikash.com",
            responseTime: "1 heure",
            availability: "24h/24",
            color: "from-purple-500 to-pink-500"
        }
    ];

    return (
        <div className="bg-gradient-to-r from-amber-600 to-orange-600 rounded-2xl shadow-lg p-8 text-white">
            <div className="text-center mb-8">
                <h2 className="text-3xl font-bold mb-2">Équipes de Support Spécialisées</h2>
                <p className="text-white/80">Contactez l'équipe la plus adaptée à votre besoin</p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
                {teams.map((team, index) => (
                    <div key={index} className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-all">
                        <div className={`w-12 h-12 bg-gradient-to-r ${team.color} rounded-lg flex items-center justify-center mb-4`}>
                            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                        </div>

                        <h3 className="font-bold text-lg mb-2">{team.name}</h3>
                        <p className="text-white/80 text-sm mb-4">{team.description}</p>

                        <div className="space-y-2 text-sm">
                            <div className="flex justify-between">
                                <span className="text-white/60">Email:</span>
                                <span className="font-medium">{team.email}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-white/60">Réponse:</span>
                                <span className="font-medium">{team.responseTime}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-white/60">Disponibilité:</span>
                                <span className="font-medium">{team.availability}</span>
                            </div>
                        </div>

                        <button className="w-full mt-4 bg-white/20 hover:bg-white/30 text-white py-2 rounded-lg font-medium transition-colors">
                            Contacter cette équipe
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SupportTeams;